#import "../../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

mutation TravelAuthorizationEmailCreate(
  $input: TravelAuthorizationEmailCreateInput!
) {
  travelAuthorizationEmailCreate(input: $input) {
    travelAuthorizationEmail {
      __typename
      id
      _emailDocument {
        ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          ...EntityEmailDocumentsFields
        }
      }
    }
  }
}
